export enum HuntGroupStrategy {
    RING_ALL = "Звонить всем",
    ROUND_ROBIN = "Звонить по кругу",
    RANDOM_UNIFORM_DISTRIBUTION = "Звонить случайному"
}
